/*
  Build your own Hamper — wizard for sections/hamper-builder.liquid
  ---------------------------------------------------------------------------
  URL contract
    /pages/<builder page>?hamper=<hamper product handle>[&for=boys|girls]

  Config comes from snippets/hamper-config.liquid (inlined by the section).
  Step products come from templates/collection.hamper-json.liquid, one request
  per collection, cached in sessionStorage for the session.

  Cart model: the hamper goes to the cart as ONE line — the hamper product
  itself, at its own price. What the customer picked (with sizes), the gift
  message and the photo ride on that line as properties. Checkout therefore
  sees a single product from the gift-hamper collection, so collection rules
  there (codes, COD, offers) apply to customisable hampers exactly as they do
  to the ready-made ones. The picked items are a packing list, not cart lines,
  so their stock is not reduced by the order — staff pick them from it.
*/
(function () {
  var root = document.querySelector('.hb');
  if (!root || root.dataset.hbInit === '1') return;
  root.dataset.hbInit = '1';

  var TTL = 30 * 60 * 1000;
  var MAX_PAGES = 6;
  // Bump this whenever collection.hamper-json.liquid changes shape. Cached
  // payloads from the old shape are then ignored instead of quietly missing
  // the new fields — that is what left the gallery showing a single image
  // after "images" was added.
  var CACHE_V = 'v2';

  var els = {
    choice: root.querySelector('[data-screen="choice"]'),
    build: root.querySelector('[data-screen="build"]'),
    review: root.querySelector('[data-screen="review"]'),
    loading: root.querySelector('[data-loading]'),
    error: root.querySelector('[data-error]')
  };

  var cartUrl = root.dataset.cartUrl || '/cart';

  // state.picks: { stepKey: [ { p: product, v: variant, qty: n } ] }
  // One row per SIZE, so the same style in two sizes is two rows.
  var state = {
    hamper: null,      // live product from /products/<handle>.js
    def: null,         // config entry
    steps: [],         // resolved steps (after a boys/girls choice)
    forLabel: '',      // "Boys" / "Girls" when the hamper forks, else ''
    stepIndex: 0,
    picks: {},
    sizes: {},         // { stepKey: { productId: variantId } } — chosen size
    returnToReview: false,
    message: '',
    photo: null,
    photoUrl: '',      // the photo's Shopify CDN link, once uploaded with the cart
    pincode: '',
    pinOk: false,
    stamp: '',         // HMP-… id of the lines this page last put in the cart
    cartSig: '',       // what those lines were built from (hamperSignature)
    busy: false
  };

  // Delivery cities + days, from snippets/hamper-service-area.liquid. Without
  // it (snippet missing) the pincode step is skipped rather than blocking sales.
  var area = window.kbHamperArea || null;
  try {
    state.pincode = localStorage.getItem('edd_pincode') || '';
  } catch (e) {}
  state.pinOk = !!(area && area.allows(state.pincode));

  /* ---------------- helpers ---------------- */

  function param(name) {
    var m = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }

  function money(paise) {
    var rupees = (paise || 0) / 100;
    return '₹' + rupees.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // The page head is one element shared by every screen, so it is retitled per
  // screen: the review step gets its own heading and drops the "pick your
  // favourites" line, which no longer applies once picking is done.
  var headTitle = root.querySelector('.hb__title');
  var headSub = root.querySelector('.hb__sub');
  var buildHeading = headTitle ? headTitle.textContent : '';
  var reviewHeading = root.dataset.reviewHeading || 'Review your hamper';

  function setHead(screen) {
    var isReview = screen === 'review';
    if (headTitle) headTitle.textContent = isReview ? reviewHeading : buildHeading;
    if (headSub) headSub.hidden = isReview;
  }

  function show(screen) {
    ['choice', 'build', 'review'].forEach(function (k) {
      els[k].hidden = k !== screen;
    });
    setHead(screen);
    els.loading.hidden = true;
    els.error.hidden = true;
  }

  function fail() {
    els.loading.hidden = true;
    els.error.hidden = false;
    ['choice', 'build', 'review'].forEach(function (k) { els[k].hidden = true; });
  }

  function cacheGet(key) {
    try {
      var box = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!box || Date.now() - box.t > TTL) return null;
      // An empty list is treated as a miss. A single bad response would
      // otherwise stick for the whole TTL and leave the step permanently blank.
      if (!box.d || !box.d.length) return null;
      return box.d;
    } catch (e) { return null; }
  }

  function cacheSet(key, data) {
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
  }

  /* ---------------- data ---------------- */

  function readConfig() {
    var node = root.querySelector('[data-hamper-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); }
    catch (e) { return null; }
  }

  function fetchHamper(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('hamper ' + r.status);
      return r.json();
    });
  }

  // One collection = one step's choices. Paginated because a collection can
  // hold more than Shopify's 50-per-page ceiling.
  function fetchCollection(handle) {
    var key = 'hb:' + CACHE_V + ':coll:' + handle;
    var cached = cacheGet(key);
    if (cached) return Promise.resolve(cached);

    var all = [];
    function step(page) {
      var url = '/collections/' + encodeURIComponent(handle) + '?view=hamper-json' + (page > 1 ? '&page=' + page : '');
      // NO Accept: application/json here. On a collection URL that header makes
      // Shopify answer with its own built-in collection JSON and ignore ?view=
      // entirely, so the custom template never renders and every step looks empty.
      return fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('collection ' + r.status);
          return r.json();
        })
        .then(function (data) {
          all = all.concat((data && data.products) || []);
          if (data && data.more && page < MAX_PAGES) return step(page + 1);
          var list = all.filter(function (p) { return p.available && p.variant_id; });
          if (list.length) cacheSet(key, list);
          return list;
        });
    }
    return step(1);
  }

  /* ---------------- selection maths ---------------- */

  function stepKey(i) { return 'step' + i; }

  function picksFor(i) { return state.picks[stepKey(i)] || []; }

  function pickedCount(i) {
    return picksFor(i).reduce(function (n, row) { return n + row.qty; }, 0);
  }

  function itemsTotal() {
    var sum = 0;
    state.steps.forEach(function (_step, i) {
      picksFor(i).forEach(function (row) { sum += row.v.price * row.qty; });
    });
    return sum;
  }

  // Sizes: which variant is armed for a given product in this step.
  function variantsOf(p) {
    return (p.variants && p.variants.length) ? p.variants : [{ id: p.variant_id, title: '', price: p.price, price_f: p.price_f }];
  }

  function hasSizes(p) {
    var vs = variantsOf(p);
    return vs.length > 1 || (vs.length === 1 && vs[0].title && vs[0].title !== 'Default Title');
  }

  function chosenVariant(i, p) {
    var vs = variantsOf(p);
    // A single-variant product needs no choosing.
    if (vs.length === 1) return vs[0];
    var map = state.sizes[stepKey(i)] || {};
    var id = map[p.id];
    var hit = vs.filter(function (v) { return v.id === id; })[0];
    return hit || null;
  }

  function chooseSize(i, productId, variantId) {
    var key = stepKey(i);
    state.sizes[key] = state.sizes[key] || {};
    state.sizes[key][productId] = variantId;
    renderBuild();
  }

  function qtyOfVariant(i, variantId) {
    var row = picksFor(i).filter(function (r) { return r.v.id === variantId; })[0];
    return row ? row.qty : 0;
  }

  function qtyOfProduct(i, productId) {
    return picksFor(i).reduce(function (n, r) { return n + (r.p.id === productId ? r.qty : 0); }, 0);
  }

  function requiredTotal() {
    return state.steps.reduce(function (n, s) { return n + s.count; }, 0);
  }

  function selectedTotal() {
    return state.steps.reduce(function (n, _step, i) { return n + pickedCount(i); }, 0);
  }

  // The hamper is sold as ONE product at its own price, whatever is picked.
  // The difference from the picked items' prices is shown on the bill as the
  // box & curation charge (or a saving when the picks come to more).
  function hamperGap() {
    return (state.hamper.price || 0) - itemsTotal();
  }

  function grandTotal() {
    return state.hamper.price || 0;
  }

  function addPick(i, product, variant) {
    var s = state.steps[i];
    if (pickedCount(i) >= s.count) return;
    if (!variant) return;
    var key = stepKey(i);
    state.picks[key] = state.picks[key] || [];
    var row = state.picks[key].filter(function (r) { return r.v.id === variant.id; })[0];
    if (row) row.qty += 1;
    else state.picks[key].push({ p: product, v: variant, qty: 1 });
    renderBuild();
    maybeAdvance(i);
  }

  function removePick(i, variantId) {
    var key = stepKey(i);
    var rows = state.picks[key] || [];
    for (var n = 0; n < rows.length; n++) {
      if (rows[n].v.id === variantId) {
        rows[n].qty -= 1;
        if (rows[n].qty <= 0) rows.splice(n, 1);
        break;
      }
    }
    renderBuild();
  }

  // Step complete → move on by itself. Short pause so the customer sees the
  // pick land before the screen changes, and a line telling them what happened
  // so it never feels like the page jumped on its own.
  function maybeAdvance(i) {
    var s = state.steps[i];
    if (!s || pickedCount(i) < s.count) return;

    var last = i === state.steps.length - 1;
    var next = last ? 'Review' : state.steps[i + 1].label;
    var note = els.build.querySelector('[data-advance]');
    if (note) {
      note.textContent = (state.returnToReview && !last)
        ? 'All set — back to your review…'
        : 'Nice! Taking you to ' + next + '…';
      note.hidden = false;
    }

    setTimeout(function () {
      // Re-check: they may have removed something during the pause.
      if (pickedCount(i) < s.count) {
        if (note) note.hidden = true;
        return;
      }
      if (state.returnToReview) { state.returnToReview = false; return renderReview(); }
      if (last) return renderReview();
      goStep(i + 1);
    }, 700);
  }

  /* ---------------- render: choice ---------------- */

  function renderChoice() {
    var c = state.def.choice;
    els.choice.innerHTML =
      '<div class="hb__panel" style="max-width:720px;margin:0 auto;text-align:center">' +
        '<h2 style="margin:0 0 16px;font-size:22px">' + esc(c.label || 'Who is this hamper for?') + '</h2>' +
        '<div class="hb__choice-grid">' +
          c.options.map(function (o, i) {
            return '<button type="button" class="hb__choice-card" data-choice="' + i + '">' +
              (o.image ? '<img src="' + esc(o.image) + '" alt="' + esc(o.label) + '">' : '') +
              '<b>' + esc(o.label) + '</b>' +
            '</button>';
          }).join('') +
        '</div>' +
      '</div>';

    els.choice.querySelectorAll('[data-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var opt = c.options[parseInt(btn.dataset.choice, 10)];
        state.steps = (opt.steps || []).slice();
        state.forLabel = opt.label || '';
        state.stepIndex = 0;
        state.picks = {};
        // Kept in the URL so a refresh or a shared link lands in the same place.
        history.replaceState(null, '', addParam('for', opt.key));
        startBuild();
      });
    });
    show('choice');
  }

  function addParam(k, v) {
    var url = new URL(window.location.href);
    url.searchParams.set(k, v);
    return url.pathname + url.search;
  }

  /* ---------------- render: build ---------------- */

  function renderBuild() {
    var i = state.stepIndex;
    var s = state.steps[i];
    if (!s) return;

    var picked = pickedCount(i);
    var products = s._products || [];

    var stepsHtml = state.steps.map(function (st, n) {
      var done = pickedCount(n) >= st.count;
      var cls = 'hb__step' + (n === i ? ' is-active' : '') + (done ? ' is-done' : '');
      return '<button type="button" class="' + cls + '" data-goto="' + n + '">' +
        '<span class="hb__step-dot">' + (done && n !== i ? '✓' : (n + 1)) + '</span>' +
        '<span class="hb__step-label">' + esc(st.label) + '</span>' +
        '<span class="hb__step-count">' + pickedCount(n) + '/' + st.count + '</span>' +
      '</button>';
    }).join('');

    var gridHtml = products.length
      ? products.map(function (p) {
          var vs = variantsOf(p);
          var sized = hasSizes(p);
          var sel = chosenVariant(i, p);
          var qty = sel ? qtyOfVariant(i, sel.id) : 0;
          var totalQty = qtyOfProduct(i, p.id);
          var full = picked >= s.count;
          var priceText = sel ? (sel.price_f || p.price_f) : p.price_f;

          var sizeHtml = sized
            ? '<div class="hb__sizes" role="group" aria-label="' + esc(p.option_name || 'Size') + '">' +
                vs.map(function (v) {
                  var on = sel && sel.id === v.id;
                  var n = qtyOfVariant(i, v.id);
                  return '<button type="button" class="hb__size' + (on ? ' is-on' : '') + (n ? ' has-qty' : '') +
                    '" data-size="' + v.id + '" data-pid="' + p.id + '">' + esc(v.title) +
                    (n ? '<i>' + n + '</i>' : '') + '</button>';
                }).join('') +
              '</div>'
            : '';

          var footHtml;
          if (sized && !sel) {
            footHtml = '<button type="button" class="hb__add" disabled>Choose a size</button>';
          } else if (qty) {
            footHtml = '<div class="hb__stepper">' +
                '<button type="button" data-minus="' + sel.id + '" aria-label="Remove one">−</button>' +
                '<span>' + qty + (sized ? ' · ' + esc(sel.title) : '') + '</span>' +
                '<button type="button" data-plus="' + sel.id + '" data-pid="' + p.id + '" aria-label="Add one"' + (full ? ' disabled' : '') + '>+</button>' +
              '</div>';
          } else {
            footHtml = '<button type="button" class="hb__add" data-add="' + (sel ? sel.id : '') + '" data-pid="' + p.id + '"' + (full ? ' disabled' : '') + '>Add +</button>';
          }

          var shots = (p.images && p.images.length) ? p.images.length : (p.image ? 1 : 0);
          return '<div class="hb__card' + (totalQty ? ' is-picked' : '') + '">' +
            '<button type="button" class="hb__card-media" data-gallery="' + p.id + '" aria-label="See ' + esc(p.title) + ' larger">' +
              (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
              '<span class="hb__card-qty">' + totalQty + '</span>' +
              '<span class="hb__card-zoom">' +
                '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/></svg>' +
                (shots > 1 ? '<i>' + shots + '</i>' : '') +
              '</span>' +
            '</button>' +
            '<div class="hb__card-body">' +
              '<h3 class="hb__card-title">' + esc(p.title) + '</h3>' +
              '<div class="hb__card-price">' + esc(priceText) + '</div>' +
              sizeHtml +
            '</div>' +
            '<div class="hb__card-foot">' + footHtml + '</div>' +
          '</div>';
        }).join('')
      : '<p style="grid-column:1/-1;opacity:.7;font-size:14px">Nothing available in this category right now.</p>';

    var slotsHtml = state.steps.map(function (st, n) {
      var rows = picksFor(n);
      var thumbs = '';
      var shown = 0;
      rows.forEach(function (r) {
        for (var q = 0; q < r.qty; q++) {
          thumbs += '<img class="hb__slot-thumb hb__slot-thumb--filled" src="' + esc(r.p.image || '') +
            '" alt="" title="' + esc(r.p.title + (r.v.title ? ' — ' + r.v.title : '')) + '">';
          shown++;
        }
      });
      for (var e = shown; e < st.count; e++) thumbs += '<span class="hb__slot-thumb"></span>';
      return '<button type="button" class="hb__slot' + (n === i ? ' is-active' : '') + '" data-goto="' + n + '">' +
        '<span>' +
          '<span class="hb__slot-name">' + esc(st.label) + '</span>' +
          '<span class="hb__slot-sub">' + pickedCount(n) + '/' + st.count + ' selected</span>' +
        '</span>' +
        '<span class="hb__slot-thumbs">' + thumbs + '</span>' +
      '</button>';
    }).join('');

    var lastStep = i === state.steps.length - 1;
    var canAdvance = picked >= s.count;

    els.build.innerHTML =
      '<div class="hb__layout">' +
        '<div class="hb__panel">' +
          '<div class="hb__steps">' + stepsHtml + '</div>' +
          '<div class="hb__notice">' +
            '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M3 12h18M12 8v13M12 8S9.5 3 7 5.5 12 8 12 8zM12 8s2.5-5 5-2.5S12 8 12 8z"/></svg>' +
            '<span>You can select up to ' + s.count + ' ' + esc(s.label) + '</span>' +
            '<span class="hb__notice-pill">' + picked + '/' + s.count + ' Selected</span>' +
          '</div>' +
          '<div class="hb__step-head">' +
            '<h2>Choose any ' + s.count + ' ' + esc(s.label) + '</h2>' +
            '<p>Pick your favourite choices and gift a hamper filled with love and care.</p>' +
          '</div>' +
          '<p class="hb__advance" data-advance hidden></p>' +
          '<div class="hb__grid">' + gridHtml + '</div>' +
        '</div>' +

        '<div class="hb__side">' +
          '<h2 class="hb__side-title">Your Hamper</h2>' +
          (state.hamper.featured_image ? '<img class="hb__side-img" src="' + esc(state.hamper.featured_image) + '" alt="' + esc(state.hamper.title) + '">' : '') +
          slotsHtml +
          '<div class="hb__totals">' +
            '<span>Items Selected<b>' + selectedTotal() + '/' + requiredTotal() + '</b></span>' +
            '<span style="text-align:right">Hamper Price<b>' + money(state.hamper.price) + '</b></span>' +
          '</div>' +
          '<button type="button" class="hb__btn" data-next' + (canAdvance ? '' : ' disabled') + '>' +
            (lastStep ? 'Review Hamper' : 'Continue') +
          '</button>' +
        '</div>' +
      '</div>';

    els.build.querySelectorAll('[data-gallery]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = products.filter(function (x) { return String(x.id) === String(b.dataset.gallery); })[0];
        if (p) openProductGallery(p);
      });
    });
    els.build.querySelectorAll('[data-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        chooseSize(i, parseInt(b.dataset.pid, 10), parseInt(b.dataset.size, 10));
      });
    });
    els.build.querySelectorAll('[data-add], [data-plus]').forEach(function (b) {
      b.addEventListener('click', function () {
        var vid = parseInt(b.dataset.add || b.dataset.plus, 10);
        var p = products.filter(function (x) { return String(x.id) === String(b.dataset.pid); })[0];
        if (!p) return;
        var v = variantsOf(p).filter(function (x) { return x.id === vid; })[0];
        if (v) addPick(i, p, v);
      });
    });
    els.build.querySelectorAll('[data-minus]').forEach(function (b) {
      b.addEventListener('click', function () { removePick(i, parseInt(b.dataset.minus, 10)); });
    });
    els.build.querySelectorAll('[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () { goStep(parseInt(b.dataset.goto, 10)); });
    });
    var next = els.build.querySelector('[data-next]');
    if (next) {
      next.addEventListener('click', function () {
        if (lastStep) renderReview();
        else goStep(i + 1);
      });
    }

    show('build');
  }

  function goStep(i) {
    if (i < 0 || i >= state.steps.length) return;
    state.stepIndex = i;
    loadStep(i).then(renderBuild).catch(renderBuild);
    window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
  }

  function loadStep(i) {
    var s = state.steps[i];
    if (!s || s._products) return Promise.resolve();
    return fetchCollection(s.collection).then(function (list) { s._products = list; });
  }

  /* ---------------- render: review ---------------- */

  function renderReview() {
    var rows = state.steps.map(function (s, i) {
      var thumbs = picksFor(i).map(function (r) {
        var label = r.p.title + (r.v.title && r.v.title !== 'Default Title' ? ' — ' + r.v.title : '');
        var out = '';
        for (var q = 0; q < r.qty; q++) {
          out += '<span class="hb__review-thumb">' +
            '<img src="' + esc(r.p.image || '') + '" alt="' + esc(label) + '" title="' + esc(label) + '">' +
            (r.v.title && r.v.title !== 'Default Title' ? '<i>' + esc(r.v.title) + '</i>' : '') +
          '</span>';
        }
        return out;
      }).join('');
      var sum = picksFor(i).reduce(function (n, r) { return n + r.v.price * r.qty; }, 0);
      return '<div class="hb__review-row">' +
        '<div class="hb__review-name">' + esc(s.label) + '<span>' + pickedCount(i) + ' selected</span></div>' +
        '<div class="hb__review-thumbs">' + thumbs + '</div>' +
        '<div class="hb__review-price">' + money(sum) + '</div>' +
        '<button type="button" class="hb__edit" data-edit="' + i + '">✎ Edit</button>' +
      '</div>';
    }).join('');

    // The hamper itself and the gift photo lead the list: they are not
    // products the customer picked, so they sit above the chosen items.
    var gap = hamperGap();
    var hamperImg = state.hamper.featured_image || '';
    var leadRows = '<div class="hb__review-row hb__review-row--hamper">' +
        '<div class="hb__review-name">Gift Hamper<span>Box, wrapping &amp; curation</span></div>' +
        '<div class="hb__review-thumbs">' +
          (hamperImg
            ? '<span class="hb__review-thumb hb__zoom" data-zoom="' + esc(hamperImg) + '" data-zoom-title="' + esc(state.hamper.title) + '" title="Tap to enlarge">' +
                '<img src="' + esc(hamperImg) + '" alt="' + esc(state.hamper.title) + '">' +
                '<b class="hb__zoom-hint">⤢</b>' +
              '</span>'
            : '') +
        '</div>' +
        '<div class="hb__review-price">' + (gap > 0 ? money(gap) : 'Included') + '</div>' +
      '</div>';

    leadRows += '<div class="hb__review-row hb__review-row--photo">' +
        '<div class="hb__review-name">Your Photo<span>Printed on the gift card</span></div>' +
        '<div class="hb__review-thumbs">' +
          (state.photo
            ? '<span class="hb__review-thumb hb__zoom" data-zoom="' + esc(state.photo.url) + '" data-zoom-title="Your photo" title="Tap to enlarge">' +
                '<img src="' + esc(state.photo.url) + '" alt="' + esc(state.photo.name) + '">' +
                '<b class="hb__zoom-hint">⤢</b>' +
              '</span>'
            : '<button type="button" class="hb__photo-slot" data-pick-photo>' +
                '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M21 16l-5-5-6 6"/></svg>' +
                '<span>Add photo</span>' +
              '</button>') +
        '</div>' +
        '<div class="hb__review-price hb__free">FREE</div>' +
        (state.photo ? '<button type="button" class="hb__edit" data-pick-photo>✎ Change</button>' : '') +
      '</div>';

    var billRows = state.steps.map(function (s, i) {
      var sum = picksFor(i).reduce(function (n, r) { return n + r.v.price * r.qty; }, 0);
      if (!sum) return '';
      return '<div class="hb__bill-row"><span>' + esc(s.label) + ' (' + pickedCount(i) + ')</span><span>' + money(sum) + '</span></div>';
    }).join('');

    els.review.innerHTML =
      '<div class="hb__gift">' +
        '<div>' +
          '<h2>Add a Gift Message</h2>' +
          '<p class="hb__hint">Your message will be printed on the gift card and packed with the hamper.</p>' +
          '<textarea maxlength="100" data-message placeholder="Write something lovely…">' + esc(state.message) + '</textarea>' +
          '<div class="hb__count"><span data-count>' + state.message.length + '</span>/100</div>' +
        '</div>' +
        '<div>' +
          '<h2>Add a Photo</h2>' +
          '<p class="hb__hint">Optional. A picture of your little one — we print it on the card.</p>' +
          '<label class="hb__drop" data-drop>' +
            '<span class="hb__free-tag">FREE</span>' +
            '<input type="file" accept="image/*" data-photo>' +
            (state.photo
              ? '<img data-preview src="' + esc(state.photo.url) + '" alt="">' +
                '<span>' + esc(state.photo.name) + ' — click to replace</span>'
              : '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M21 16l-5-5-6 6"/></svg>' +
                '<span>Click to upload a photo</span>') +
          '</label>' +
        '</div>' +
      '</div>' +

      '<div class="hb__layout">' +
        '<div class="hb__panel">' +
          '<div class="hb__notice">' +
            '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M3 12h18M12 8v13"/></svg>' +
            '<span>Great! You\'ve selected all your favourites. Take a quick look to verify.</span>' +
          '</div>' +
          leadRows +
          rows +
        '</div>' +

        '<div class="hb__side">' +
          '<h2 class="hb__side-title">Hamper Billing</h2>' +
          (state.hamper.featured_image ? '<img class="hb__side-img" src="' + esc(state.hamper.featured_image) + '" alt="">' : '') +
          '<div style="font-weight:700;font-size:13px;margin-bottom:6px">Order Summary</div>' +
          billRows +
          (gap > 0
            ? '<div class="hb__bill-row hb__bill-row--balance"><span>Hamper, box &amp; curation</span><span>' + money(gap) + '</span></div>'
            : '') +
          (gap < 0
            ? '<div class="hb__bill-row hb__bill-row--balance"><span>Hamper saving</span><span>−' + money(-gap) + '</span></div>'
            : '') +
          '<div class="hb__bill-sep"></div>' +
          '<div class="hb__bill-row"><span>Shipping</span><span class="hb__free">FREE</span></div>' +
          '<div class="hb__bill-sep"></div>' +
          '<div class="hb__bill-total"><span>Total Price</span><span>' + money(grandTotal()) + '</span></div>' +
          (area
            ? '<div class="hb__pin">' +
                '<label class="hb__pin-label" for="hb-pin-' + root.id + '">Delivery pincode</label>' +
                '<div class="hb__pin-row">' +
                  '<input id="hb-pin-' + root.id + '" type="text" inputmode="numeric" maxlength="6" autocomplete="postal-code" placeholder="6-digit pincode" data-pin value="' + esc(state.pincode) + '">' +
                  '<button type="button" data-pin-check>Check</button>' +
                '</div>' +
                '<p class="hb__pin-msg" data-pin-msg></p>' +
              '</div>'
            : '') +
          '<button type="button" class="hb__btn hb__btn--buy" data-checkout' + (area && !state.pinOk ? ' disabled' : '') + '>' +
            BUY_HTML +
          '</button>' +
          '<button type="button" class="hb__btn hb__btn--ghost" data-back>Back to editing</button>' +
        '</div>' +
      '</div>';

    els.review.querySelectorAll('[data-edit]').forEach(function (b) {
      b.addEventListener('click', function () {
        // Editing one category should land back here, not walk the whole
        // wizard again once the step is refilled.
        state.returnToReview = true;
        goStep(parseInt(b.dataset.edit, 10));
      });
    });
    var back = els.review.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () {
      state.returnToReview = false;
      goStep(state.stepIndex);
    });

    var ta = els.review.querySelector('[data-message]');
    var counter = els.review.querySelector('[data-count]');
    if (ta) {
      ta.addEventListener('input', function () {
        state.message = ta.value;
        if (counter) counter.textContent = ta.value.length;
      });
    }

    var file = els.review.querySelector('[data-photo]');
    if (file) {
      file.addEventListener('change', function () {
        var f = file.files && file.files[0];
        if (!f) return;
        state.photo = { file: f, name: f.name, url: URL.createObjectURL(f) };
        renderReview();
      });
    }

    // Tap any thumbnail in the list to see it full size.
    els.review.querySelectorAll('[data-zoom]').forEach(function (z) {
      z.addEventListener('click', function () { openZoom(z.dataset.zoom, z.dataset.zoomTitle); });
    });

    // Both the empty "Add photo" slot and the "Change" button drive the one
    // real file input up in the gift panel.
    els.review.querySelectorAll('[data-pick-photo]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = els.review.querySelector('[data-photo]');
        if (input) input.click();
      });
    });

    var go = els.review.querySelector('[data-checkout]');
    if (go) go.addEventListener('click', addToCart);

    var pin = els.review.querySelector('[data-pin]');
    if (pin) {
      // Checked as they type, so a full pincode unlocks BUY NOW without a click.
      pin.addEventListener('input', function () {
        pin.value = pin.value.replace(/\D/g, '');
        setPin(pin.value, false);
      });
      pin.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); setPin(pin.value, true); }
      });
      els.review.querySelector('[data-pin-check]').addEventListener('click', function () { setPin(pin.value, true); });
    }
    paintPin();

    show('review');
    window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
  }

  /* ---------------- delivery pincode ---------------- */

  // Hampers only go to the cities in Theme settings → Gift Hampers, so BUY NOW
  // stays locked until the pincode is one of them. Shared with the product
  // page checker through the same localStorage key.
  function setPin(value, insist) {
    state.pincode = value;
    state.pinOk = !!(area && area.allows(value));
    if (value.length === 6) {
      try { localStorage.setItem('edd_pincode', value); } catch (e) {}
    }
    paintPin(insist);
  }

  function paintPin(insist) {
    var msg = els.review.querySelector('[data-pin-msg]');
    var go = els.review.querySelector('[data-checkout]');
    if (!area || !msg) return;
    var pin = state.pincode;
    if (state.pinOk) {
      msg.className = 'hb__pin-msg is-ok';
      msg.textContent = '✓ We deliver to ' + pin + ' — arrives ' + area.eta();
    } else if (pin.length === 6) {
      msg.className = 'hb__pin-msg is-bad';
      msg.textContent = 'Sorry, we deliver gift hampers only in ' + area.cities + ' for now.';
    } else if (insist) {
      msg.className = 'hb__pin-msg is-bad';
      msg.textContent = 'Please enter a valid 6-digit pincode.';
    } else {
      msg.className = 'hb__pin-msg';
      msg.textContent = 'We deliver hampers in ' + area.cities + ' (' + area.min + '–' + area.max + ' days). Enter your pincode to continue.';
    }
    if (go && !state.busy) go.disabled = !state.pinOk;
  }

  /* ---------------- lightbox ---------------- */

  var zoomBox = null;
  var gal = { list: [], i: 0, title: '' };

  // One image (a hamper photo, the gift photo) is just a gallery of one.
  function openZoom(src, title) {
    openGallery([src], 0, title || '');
  }

  function handleOf(p) {
    if (p.handle) return p.handle;
    var m = /\/products\/([^?#/]+)/.exec(p.url || '');
    return m ? m[1] : '';
  }

  // Opens straight away with whatever images we already have, then tops the
  // gallery up from the product's own JSON if that list looks short. Covers
  // stale caches and any product whose step data predates the images field.
  function openProductGallery(p) {
    var have = (p.images && p.images.length) ? p.images.slice() : (p.image ? [p.image] : []);
    openGallery(have, 0, p.title);

    if (p._imgsDone || have.length > 1) return;
    p._imgsDone = true;

    var h = handleOf(p);
    if (!h) return;

    fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.images || d.images.length <= have.length) return;
        // /products/x.js returns protocol-relative URLs.
        var list = d.images.map(function (u) { return u.indexOf('//') === 0 ? 'https:' + u : u; });
        p.images = list;
        // Only refresh the viewer if it is still showing this product.
        if (zoomBox && zoomBox.classList.contains('is-open') && gal.title === p.title) {
          gal.list = list;
          renderZoom();
        }
      })
      .catch(function () { /* the single image we already show is fine */ });
  }

  function openGallery(list, index, title) {
    list = (list || []).filter(Boolean);
    if (!list.length) return;
    gal.list = list;
    gal.i = Math.min(Math.max(index || 0, 0), list.length - 1);
    gal.title = title || '';

    if (!zoomBox) {
      zoomBox = document.createElement('div');
      zoomBox.className = 'hb__lightbox';
      zoomBox.innerHTML =
        '<button type="button" class="hb__lightbox-x" aria-label="Close">×</button>' +
        '<div class="hb__lb-stage">' +
          '<button type="button" class="hb__lb-nav hb__lb-prev" aria-label="Previous image">‹</button>' +
          '<img class="hb__lb-img" alt="">' +
          '<button type="button" class="hb__lb-nav hb__lb-next" aria-label="Next image">›</button>' +
        '</div>' +
        '<p class="hb__lb-caption"></p>' +
        '<div class="hb__lb-thumbs"></div>';

      zoomBox.addEventListener('click', function (e) {
        var t = e.target;
        if (t === zoomBox || t.classList.contains('hb__lightbox-x')) return closeZoom();
        if (t.classList.contains('hb__lb-prev')) return stepGallery(-1);
        if (t.classList.contains('hb__lb-next')) return stepGallery(1);
        var th = t.closest ? t.closest('[data-thumb]') : null;
        if (th) { gal.i = parseInt(th.dataset.thumb, 10); renderZoom(); }
      });
      root.appendChild(zoomBox);
    }

    renderZoom();
    zoomBox.classList.add('is-open');
    document.addEventListener('keydown', onZoomKey);
  }

  function renderZoom() {
    if (!zoomBox) return;
    var many = gal.list.length > 1;
    zoomBox.querySelector('.hb__lb-img').src = gal.list[gal.i];
    zoomBox.querySelector('.hb__lb-caption').textContent =
      gal.title + (many ? '  ·  ' + (gal.i + 1) + ' / ' + gal.list.length : '');
    zoomBox.querySelector('.hb__lb-prev').hidden = !many;
    zoomBox.querySelector('.hb__lb-next').hidden = !many;
    zoomBox.querySelector('.hb__lb-thumbs').innerHTML = many
      ? gal.list.map(function (src, n) {
          return '<button type="button" class="hb__lb-thumb' + (n === gal.i ? ' is-on' : '') +
            '" data-thumb="' + n + '"><img src="' + esc(src) + '" alt=""></button>';
        }).join('')
      : '';
  }

  function stepGallery(d) {
    if (!gal.list.length) return;
    gal.i = (gal.i + d + gal.list.length) % gal.list.length;
    renderZoom();
  }

  function closeZoom() {
    if (zoomBox) zoomBox.classList.remove('is-open');
    document.removeEventListener('keydown', onZoomKey);
  }

  function onZoomKey(e) {
    if (e.key === 'Escape') return closeZoom();
    if (e.key === 'ArrowLeft') return stepGallery(-1);
    if (e.key === 'ArrowRight') return stepGallery(1);
  }

  /* ---------------- cart ---------------- */

  var BUY_HTML = '<span>BUY NOW</span>' +
    '<img src="https://fastrr-boost-ui.pickrr.com/assets/images/boost_button/upi_options.svg" alt="Google Pay | PhonePe | UPI">';

  // Puts BUY NOW back after a hand-off or a failure, so a customer who closes
  // the checkout popup can press it again.
  function releaseBuy() {
    state.busy = false;
    var b = els.review.querySelector('[data-checkout]');
    if (!b) return;
    b.innerHTML = BUY_HTML;
    b.disabled = !!(area && !state.pinOk);
  }

  // Everything that decides what goes in the cart. Same signature as last
  // time → the lines already in the cart are still right.
  function hamperSignature() {
    var picks = [];
    state.steps.forEach(function (_s, i) {
      picksFor(i).forEach(function (r) { picks.push(r.v.id + 'x' + r.qty); });
    });
    var f = state.photo && state.photo.file;
    return JSON.stringify([
      state.hamper.handle, picks, state.message, state.pincode,
      f ? [f.name, f.size, f.lastModified] : null
    ]);
  }

  // What goes in the box, one entry per step:
  //   { label: 'Rompers', text: 'Blue Star Romper (3-6M) ×2, Duck Romper (0-3M)' }
  function packingList() {
    return state.steps.map(function (s, i) {
      var parts = picksFor(i).map(function (r) {
        var size = r.v.title && r.v.title !== 'Default Title' ? ' (' + r.v.title + ')' : '';
        return r.p.title + size + (r.qty > 1 ? ' ×' + r.qty : '');
      });
      return { label: s.label, text: parts.join(', ') };
    }).filter(function (x) { return x.text; });
  }

  // The hamper product's own variant — the one line that goes to the cart.
  function hamperVariantId() {
    var vs = state.hamper.variants || [];
    var v = vs.filter(function (x) { return x.available; })[0] || vs[0];
    return v ? v.id : 0;
  }

  function addToCart() {
    if (state.busy) return;
    if (area && !state.pinOk) {
      paintPin(true);
      var pinInput = els.review.querySelector('[data-pin]');
      if (pinInput) pinInput.focus();
      return;
    }
    state.busy = true;
    var btn = els.review.querySelector('[data-checkout]');
    if (btn) { btn.disabled = true; btn.innerHTML = '<span>Adding to cart…</span>'; }

    var sig = hamperSignature();
    var oldStamp = state.stamp;
    var stamp = 'HMP-' + Date.now().toString(36).toUpperCase();
    var name = state.def.name || state.hamper.title;
    var packing = packingList();

    // The single hamper line. Each step becomes one visible property
    // ("Rompers: Blue Star Romper (3-6M) ×2, …") so the order reads as a
    // packing list; _items keeps the exact variant ids for anyone automating
    // stock later. The photo is added as a file in addMultipart.
    function hamperProps() {
      var p = { _hamper_id: stamp, Hamper: name };
      if (state.forLabel) p.For = state.forLabel;
      packing.forEach(function (x) { p[x.label] = x.text; });
      if (state.message) p['Gift message'] = state.message;
      var ids = [];
      state.steps.forEach(function (_s, i) {
        picksFor(i).forEach(function (r) { ids.push(r.v.id + ':' + r.qty); });
      });
      p._items = ids.join(',');
      return p;
    }

    // Multipart add — the only form that can carry the photo file.
    function addMultipart(id, quantity, props) {
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', quantity);
      Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
      if (state.photo && state.photo.file) fd.append('properties[Photo]', state.photo.file);
      return fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { if (!r.ok) throw new Error('add-file ' + r.status); return r.json(); })
        .then(function (line) {
          // Shopify swaps the uploaded file for its CDN link; keep it so the
          // link can also go in the order note (see saveGiftDetails).
          var url = (line && line.properties && line.properties.Photo) || '';
          state.photoUrl = url.indexOf('//') === 0 ? 'https:' + url : url;
          return line;
        });
    }

    // The same details again, at order level: the cart note and cart
    // attributes. Line properties sit under one line item deep in the order
    // and depend on the checkout app carrying them over; the note is the first
    // thing staff see on the order, and it reaches the order by a separate
    // route. Best effort — a failure here never blocks the purchase.
    function saveGiftDetails() {
      var block = [
        '🎁 GIFT HAMPER — ' + name + (state.forLabel ? ' · ' + state.forLabel : '') + ' (' + stamp + ')',
        'Gift message: ' + (state.message || 'not added'),
        'Photo: ' + (state.photoUrl || 'not added'),
        'Delivery pincode: ' + (state.pincode || 'not given'),
        'Items:'
      ].concat(packing.map(function (x) { return '• ' + x.label + ': ' + x.text; })).join('\n');
      // An empty value deletes the attribute, which also clears any left
      // over from an earlier attempt in the same cart.
      var attrs = {
        'Gift hamper': name + ' (' + stamp + ')',
        'Gift message': state.message || '',
        'Gift photo': state.photoUrl || '',
        'Delivery pincode': state.pincode || ''
      };
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Keep whatever note the customer wrote; replace an older hamper block.
          var own = String(cart.note || '').split('🎁 GIFT HAMPER')[0].trim();
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: (own ? own + '\n\n' : '') + block, attributes: attrs })
          });
        })
        .catch(function () { /* the line properties still carry the details */ });
    }

    function addLines() {
      var id = hamperVariantId();
      if (!id) return Promise.reject(new Error('hamper has no variant'));
      return addMultipart(id, 1, hamperProps());
    }

    // A second BUY NOW (customer closed the checkout popup and pressed it
    // again) must not put a second copy of the hamper in the cart. If the
    // earlier line is still there and nothing changed, just reopen checkout;
    // otherwise take it out before adding the new one.
    var wantQty = 1;

    function clearEarlier() {
      if (!oldStamp) return Promise.resolve(false);
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var mine = (cart.items || []).filter(function (it) {
            return it.properties && it.properties._hamper_id === oldStamp;
          });
          var haveQty = mine.reduce(function (n, it) { return n + it.quantity; }, 0);
          if (mine.length && sig === state.cartSig && haveQty === wantQty) return true;
          if (!mine.length) return false;
          var updates = {};
          mine.forEach(function (it) { updates[it.key] = 0; });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function (r) { if (!r.ok) throw new Error('clear ' + r.status); return false; });
        });
    }

    clearEarlier()
      .then(function (alreadyInCart) {
        if (alreadyInCart) return;
        state.stamp = stamp;
        return addLines()
          .then(saveGiftDetails)
          .then(function () { state.cartSig = sig; });
      })
      .then(goToCheckout)
      .catch(function () {
        releaseBuy();
        alert('Sorry — we could not add this hamper to your cart. Please try again.');
      });
  }

  // True while the Shiprocket popup is actually on screen. Its iframe stays
  // in the page after it closes, so being present is not enough.
  function checkoutOpen() {
    var nodes = document.querySelectorAll('iframe[src*="fastrr"], iframe[src*="pickrr"], .sr-modal, #sr-checkout-modal');
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      if (r.width > 50 && r.height > 50) return true;
    }
    return false;
  }

  // Straight into the store's own checkout. The site runs Shiprocket headless
  // (the cart page's BUY NOW is shiprocketCheckoutEvents.buyCart), and that
  // global is loaded on every page, so the hamper can hand off to the same
  // flow. If it is ever missing, fall back to the cart page, which carries
  // its own BUY NOW button.
  function goToCheckout() {
    try {
      var sr = window.shiprocketCheckoutEvents;
      if (sr && typeof sr.buyCart === 'function') {
        sr.buyCart(new Event('click'));
        // buyCart opens its own overlay; if nothing happened, the cart is the
        // safe landing spot rather than leaving the customer on a dead button.
        // Once it is up, free BUY NOW underneath it: the popup covers the page,
        // and a customer who closes it can press BUY NOW again.
        setTimeout(function () {
          if (!checkoutOpen()) {
            window.location.href = cartUrl;
            return;
          }
          releaseBuy();
        }, 2500);
        return;
      }
    } catch (e) { /* fall through to the cart */ }
    window.location.href = cartUrl;
  }

  /* ---------------- boot ---------------- */

  function startBuild() {
    // Drop steps whose collection is missing or empty so a bad handle never
    // strands the customer on an empty screen.
    var jobs = state.steps.map(function (s) {
      return fetchCollection(s.collection)
        .then(function (list) { s._products = list; })
        .catch(function () { s._products = []; });
    });
    Promise.all(jobs).then(function () {
      state.steps = state.steps.filter(function (s) { return s._products && s._products.length; });
      if (!state.steps.length) return fail();
      state.stepIndex = 0;
      renderBuild();
    });
  }

  // Which config entry describes this hamper? The key is tried first, then the
  // entry's "tag" against the product's own tags (new_born / celebration /
  // birthday). Tag matching survives a product rename and lets several
  // products share one hamper type.
  function resolveDef(cfg, handle, tags) {
    if (cfg.hampers[handle]) return cfg.hampers[handle];
    var mine = (tags || []).map(function (t) { return String(t).toLowerCase(); });
    var keys = Object.keys(cfg.hampers);
    for (var i = 0; i < keys.length; i++) {
      var def = cfg.hampers[keys[i]];
      if (def.tag && mine.indexOf(String(def.tag).toLowerCase()) !== -1) return def;
    }
    return null;
  }

  function init() {
    var cfg = readConfig();
    var handle = param('hamper');
    if (!cfg || !cfg.hampers || !handle) return fail();

    fetchHamper(handle)
      .then(function (p) {
        state.hamper = p;
        state.def = resolveDef(cfg, handle, p.tags);
        if (!state.def) return fail();
        var pre = param('for');
        if (state.def.choice) {
          var opt = (state.def.choice.options || []).filter(function (o) { return o.key === pre; })[0];
          if (!opt) return renderChoice();
          state.steps = (opt.steps || []).slice();
          state.forLabel = opt.label || '';
        } else {
          state.steps = (state.def.steps || []).slice();
        }
        if (!state.steps.length) return fail();
        startBuild();
      })
      .catch(fail);
  }

  init();
})();
